export const SET_SKELETON = 'SET_SKELETON'

export const setSkeleton = (show: boolean) => ({
  type: SET_SKELETON,
  payload: {
    show,
  },
})
